import React from "react";
import "./MotorInsurance.scss";
import motorService from "../../../assets/Services/motor-service.png";
import motorImg from "../../../assets/Services/motor-img.jpg";

const MotorInsurance = () => {
  return (
    <>
      <div className="motor_service">
        <div className="container-fluid p-0">
          <div
            className="back_bg"
            style={{ backgroundImage: `url(${motorService})` }}
          ></div>
          <div className="heading_box">Motor Insurance</div>
          <div className="service_content">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 my-auto">
                  <div className="left mb-4 mb-lg-0">
                    <h4>Motor INSURANCES</h4>
                    <ul>
                      <li>Motor Insurances for Commercial use.</li>
                      <li>Motor Insurances for Private use.</li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-6 my-auto">
                  <img src={motorImg} className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
    </>
  );
};

export default MotorInsurance;
